module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_10 (17).690d66f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_10 (17).mp4
// module id = 792
// module chunks = 1